import React, { ComponentProps, FunctionComponent } from "react";

const CloseIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: "1.2",
      d: "M4 4L12 12M12 4L4 12",
    })
  );
};

const ForwardRef = React.forwardRef(CloseIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
